// extracted by mini-css-extract-plugin
export default {"base":"vp_sioY1","activity":"vp_I2iFn","loading":"vp_mHUkr"};